module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp10-aeb5c58778e670ec0c06fb5991817e37.jpg";